// TODO: CSS 共同文本
const PORT_HTTPS="8099"
// const PORT_HTTP="1234"
// const PORT_HTTP="8081"
const PORT_HTTP="8080"
const PROD_KEY_PORT="8081"
// const HOST = "mwgcare.kmtth.org.tw"
// const HOST = "192.168.0.186"
// const HOST = "192.168.0.100"
// const HOST = "192.168.0.99"
const HOST = "25.4.116.97"
// const HOST = "172.26.2.91"
const LOCATION = window.location
const comm_data = Object.freeze({
    // NOTE: API 相關資料
    API_SERVES_PORT:"8080",

    // for local !
    // API_HOST_MQTT: HOST,
    // API_HOST: `${LOCATION.protocol}//${HOST}:${(LOCATION.protocol==="http:")?PORT_HTTP:PORT_HTTPS}`,
    // API_PROD_KEY_HOST: "http://192.168.0.51:8082", // 產品金錀的URL
    // HIGHCHARTS_SERVER: "http://192.168.0.50:7801",

    // for server
    API_HOST_MQTT: window.location.hostname,
    API_HOST: `${(window.location.protocol==="http:")?"http":"https"}://` + window.location.hostname+":"+`${(LOCATION.protocol==="http:")?PORT_HTTP:PORT_HTTPS}`,
    API_PROD_KEY_HOST: "http://"+window.location.hostname+":"+PROD_KEY_PORT, // 產品金錀的URL
    API_SCIENTECH_PORT: "81",

    //Alert level int to str
    LEVEL_0:"normal",
    LEVEL_1:"warning",
    LEVEL_2:"emergency",

    // ✎NOTE: Alert State
    ALERT_STATE_1: 'GLOBAL.ALERT_STATE_1',
    ALERT_STATE_4: 'GLOBAL.ALERT_STATE_4',
    ALERT_STATE_7: 'GLOBAL.ALERT_STATE_7',
    ALERT_STATE_8: 'GLOBAL.ALERT_STATE_8',
    ALERT_STATE_12: 'GLOBAL.ALERT_STATE_12',
    ALERT_STATE_13: 'GLOBAL.ALERT_STATE_13',
    ALERT_STATE_14: 'GLOBAL.ALERT_STATE_14',
    ALERT_STATE_15: 'GLOBAL.ALERT_STATE_15',
    ALERT_STATE_103: 'GLOBAL.ALERT_STATE_103',
    ALERT_STATE_203: 'GLOBAL.ALERT_STATE_203',
    ALERT_STATE_206: 'GLOBAL.ALERT_STATE_206',
    ALERT_STATE_208: 'GLOBAL.ALERT_STATE_208',
    
    ALERT_STATE_210: 'GLOBAL.ALERT_STATE_210',
    
    ALERT_STATE_211: 'GLOBAL.ALERT_STATE_211',
    ALERT_STATE_212: 'GLOBAL.ALERT_STATE_212',

    ALERT_STATE_217: 'GLOBAL.ALERT_STATE_217',
    ALERT_STATE_218: 'GLOBAL.ALERT_STATE_218',
    ALERT_STATE_501: 'GLOBAL.ALERT_STATE_501',
    ALERT_STATE_502: 'GLOBAL.ALERT_STATE_502',
    ALERT_STATE_503: 'GLOBAL.ALERT_STATE_503',
    ALERT_STATE_504: 'GLOBAL.ALERT_STATE_504',
    ALERT_STATE_505: 'GLOBAL.ALERT_STATE_505',
    ALERT_STATE_511: 'GLOBAL.ALERT_STATE_511',
    ALERT_STATE_512: 'GLOBAL.ALERT_STATE_512',



})

export default comm_data;
// export default common_data;
